import {ISymbol, SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {gsap, TimelineLite} from "gsap";
import {TrueGrit} from "../TrueGrit";
import {TrueGritTopReelView} from "../view/reels/TrueGritTopReelView";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

/**
 * Created by Jerker Nord on 2021-07-08.
 */

export class TrueGritTopReelModel {

    public readonly events:APIEventSystem | undefined;
    private _reelId:number = 6;
    private _state:SimpleReelModelState = SimpleReelModelState.IDLE;

    constructor() {
        this.events = SlotGame.apiPlugin.eventSystemFactory.create();
        this.events.on("ReelStateChange", (data:SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
    }

    private onReelStateChange(data:SimpleReelModelEventData):void {
        this.events?.trigger(data.state, data);
    }

    public clear(){
        TrueGrit.topReelView.clear();
    }

    public init(symbols:string[], isAvalancheRestore:boolean) {
        TrueGrit.topReelView.initReel(symbols, isAvalancheRestore);
    }

    public getFillUpReelAnimation():gsap.core.Timeline {
        return TrueGrit.topReelView.getFillUpReelAnimation();
    }

    public getSymbolBySymbolPosition(index:number):ISymbol {
        return TrueGrit.topReelView.getSymbolBySymbolPosition(index);
    }

    /**
     * Calculates which symbols that should fall down and how many steps
     */
    public collapseReel():gsap.core.Timeline {
        return TrueGrit.topReelView.collapseTopReel();
    }

    public stop(reelData:string[]):TimelineLite {
        const tl:gsap.core.Timeline = gsap.timeline({
            onComplete : () => {
                this.state = SimpleReelModelState.STOPPED;
                this.state = SimpleReelModelState.IDLE;
            }
        });
        tl.add(TrueGrit.topReelView.stop(reelData));

        return tl;
    }

    /**
     * Adding bounce on reel spin start
     */
    public start():TimelineLite {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {this.state = SimpleReelModelState.START});
        tl.add(() => this.startSpin());

        return tl;
    }

    public getAllSymbols():ISymbol[] {
        return TrueGrit.topReelView.getAllSymbols();
    }

    /**
     * Starting the actual spin by adding it to the masterSpinTimeline
     * @private
     */
    private startSpin() {
        this.state = SimpleReelModelState.SPIN;
        this.spin();
    }

    private spin():TimelineLite {
        const timeline:gsap.core.Timeline = gsap.timeline();
        timeline.add(() => {TrueGrit.topReelView.getAllOutAnimation()});
        timeline.add(() => this.onSpinStartedCompleted());
        return timeline;
    }

    private onSpinStartedCompleted():void {

    }

    set state(value:SimpleReelModelState) {
        this._state = value;
        if(this.events) {
            this.events.trigger("ReelStateChange", <SimpleReelModelEventData>{
                reel : this._reelId,
                state : this._state
            });
        }
    }

    get reelView():TrueGritTopReelView {
        return TrueGrit.topReelView;
    }
}